var exports = {
  "x": "x04b3a21e--7fdb24--button",
};

module.exports = exports;
